import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import * as PropTypes from 'prop-types';
import { Stack, Dropdown, Text, Label } from '@fluentui/react';
import { getPriceString } from '@shared/utils/pricing';
import { useId } from '@fluentui/react-hooks';
const stackStyles = {
    root: {
        paddingTop: '20px'
    }
};
export function ConsentModalPlan({ plans, selectedPlanId, countryCode, locale, onPlanChange }, context) {
    const pricingLabelId = useId();
    const descriptionLabelId = useId();
    const selectedPlan = plans === null || plans === void 0 ? void 0 : plans.find(({ id })=>id === selectedPlanId);
    if (!selectedPlan) {
        return null;
    }
    const { id, title, description, startingPrice, currencyCode, isQuantifiable } = selectedPlan;
    return /*#__PURE__*/ _jsxs(Stack, {
        tokens: {
            childrenGap: 10
        },
        styles: stackStyles,
        children: [
            /*#__PURE__*/ _jsx(Dropdown, {
                selectedKey: id,
                label: context.loc('ConsentModal_Plan_Label', 'Plan'),
                ariaLabel: context.loc('ConsentModal_Plan_Label', 'Plan'),
                options: plans.map(({ id, title, description })=>({
                        key: id,
                        text: title,
                        title: description
                    })),
                onChange: (_, { key })=>onPlanChange(key)
            }),
            startingPrice && /*#__PURE__*/ _jsxs(Stack, {
                children: [
                    /*#__PURE__*/ _jsx(Label, {
                        id: pricingLabelId,
                        children: context.loc('ConsentModal_Plan_Pricing_Label', 'Pricing')
                    }),
                    /*#__PURE__*/ _jsx(Text, {
                        "aria-labelledby": pricingLabelId,
                        children: context.locParams('StartingAtPrice', [
                            getPriceString({
                                context,
                                price: startingPrice,
                                countryCode,
                                currency: currencyCode,
                                isQuantifiable,
                                locale
                            })
                        ])
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(Stack, {
                children: [
                    /*#__PURE__*/ _jsx(Label, {
                        id: descriptionLabelId,
                        children: context.loc('ConsentModal_Plan_Description_Label', 'Description')
                    }),
                    /*#__PURE__*/ _jsx(Text, {
                        "aria-labelledby": descriptionLabelId,
                        title: description,
                        children: title
                    })
                ]
            })
        ]
    });
}
ConsentModalPlan.contextTypes = {
    locParams: PropTypes.func,
    loc: PropTypes.func
};
